
/**
 * Fits an element to its parent
 * @param $el
 * @param options
 */
var TeamPopups = {
    initialised: false
};

/**
 * Add event listeners
 */
TeamPopups.init = function()
{
    if (this.initialised) {
        return;
    }

    $(document).on('click', '[data-team-popup]', function(e) {
        
        var url = $(e.currentTarget).attr("data-team-url");
        console.log(url);
        this.showPopup(url);
    }.bind(this));

    this.initialised = true;
}

/**
 * Update all elements
 */
TeamPopups.showPopup = function(src)
{
    $.magnificPopup.open({
        mainClass: 'team-member-single-popup mfp-zoom-in mfp-custom',
        closeBtnInside: true,
        fixedContentPos: true,
        autoFocusLast: false,
        items: {
            src: src,
            type: 'ajax'
        }
    });
}

export default TeamPopups;